import Service from './Service';

class CimService extends Service {
    getVarosLista(irszam) {
        if (irszam === null) return Promise.reject();
        return this.get('varoslista?', { irszam });
    }

    getEmeletLista() {
        return this.get('emeletLista', {});
    }

    getKozterTipusLista() {
        return this.get('kozterTipusLista', {});
    }

    getKozterLista(idvaros) {
        if (idvaros === null) return Promise.reject();
        return this.get('kozteruletLista?', { idvaros });
    }

    getKozteruletByName(idvaros, kozternev) {
        return this.get('kozteruletByName?', { idvaros, kozternev });
    }
}

export default new CimService('/api/cim/');
